import { hasOwn } from './util';

export function isVNode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions');
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/utils/vdom.js